
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/mcp-server",
      function () {
        return require("private-next-pages/apipages/mcp-server/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/mcp-server"])
      });
    }
  